module.exports = __webpack_public_path__ + "img/32.10.pH.4e497348.png";